var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRecommendedTag = function SvgRecommendedTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 69,
    viewBox: "0 10 28 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA580C",
    d: "M44 8.25H16v36l14-6 14 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30 29.643 5.15 3.108-1.367-5.858 4.55-3.942-5.992-.508-2.342-5.525-2.341 5.525-5.992.508 4.55 3.942-1.367 5.858z"
  })));
};
export default SvgRecommendedTag;